import { scrollToElement, getElementOffset } from '../services/layout'

export default {
    name: 'scroll-to',
    bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'string') {
            const compName = vNode.context.name;
            let warn = `[scroll-to:] provided expression '${binding.expression}' is not a string, but has to be`;
            if (compName) { warn += `Found in component '${compName}'` }

            console.warn(warn);
        }

        el.style.cursor = 'pointer';

        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const $html = document.querySelector('html');
        const $body = document.querySelector('body');
        const handler = (e) => {
            e.preventDefault();

            const $targetId = '#' + binding.value;
            const $target = document.querySelector($targetId);

            if (!$target) return;

            let $targetOffsetTop = getElementOffset($target).top;

            if (binding.modifiers.center) {
                const elementHeight = $target.clientHeight;
                $targetOffsetTop += elementHeight / 2;
                $targetOffsetTop -= window.innerHeight / 2;
            }

            $targetOffsetTop = Math.round($targetOffsetTop);

            // prevent scrolling if target is too close
            if (Math.abs($targetOffsetTop - Math.max($html.scrollTop, $body.scrollTop)) < 55) return;

            scrollToElement($html, $targetOffsetTop, 400);
            scrollToElement($body, $targetOffsetTop, 400);

            if (el.tagName.toLowerCase() === 'a') {
                history.pushState(null, null, $targetId);
            }

            // This part only for Vue components, what have listener on 'EXPAND_SECTION' action
            if (!$target.__vue__) return;

            $target.__vue__.$emit('EXPAND_SECTION');
        };
        el.__ScrollTo__ = handler;

        // add Event Listeners
        el.addEventListener('click', handler);
    },
    unbind: function(el) {
        // Remove Event Listeners
        el.removeEventListener('click', el.__ScrollTo__);
        el.__ScrollTo__ = null;

    }
}



// WEBPACK FOOTER //
// ./src/directives/ScrollTo.js